import Chunk from 'nanogl-pbr/Chunk'
import ChunksSlots from 'nanogl-pbr/ChunksSlots'
import Input, { ShaderType } from 'nanogl-pbr/Input'
import TexCoord from 'nanogl-pbr/TexCoord'

export default class AntialiasedLine extends Chunk {
  private uvs: Input

  constructor() {
    super(true, false)
    this.addChild((this.uvs = new Input('TexCoord', 2, ShaderType.FRAGMENT)))
    this.uvs.attachAttribute(TexCoord.create('aTexCoord0').attrib)
  }

  protected _genCode(slots: ChunksSlots): void {
    slots.add(
      'postf',
      /*glsl*/ `
      vec2 uv = TexCoord();
      float alpha = smoothstep(0.0, 0.5, uv.y) * smoothstep(1.0, 0.5, uv.y);
      FragColor.a = clamp(alpha, 0.0, 1.0);
      `
    )
  }
}
